import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_plan_maintenance_maintenance_item_code'),
        dataIndex: 'itemCode',
        key: 'itemCode',
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_items'),
        dataIndex: 'itemName',
        key: 'itemName',
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_requirements'),
        dataIndex: 'itemRequirement',
        key: 'itemRequirement',
        ellipsis: true
      },
      {
        title: this.$t('remark'),
        dataIndex: 'itemRemark',
        key: 'itemRemark',
        ellipsis: true
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;

  render() {
    return (
      <div>
        <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            row-key="id"
            loading={this.loading}
            scroll={{ y: this.height}}
        >
        </ml-table>
      </div>
    )
  }
}